import request from '@/common/request';

// 获取应用列表
export async function getAppList(data) {
  return request({ url: '/qunion/media/list', method: 'post', data });
}

// 获取应用列表all
export async function getAppAllList(params) {
	return request({ url: '/qunion/media/all-list-qtt-union', method: 'get', params });
}

// 媒体行业
export async function getCategoryList(params) {
	return request({ url: 'media/category', method: 'get', params });
}

// 媒体新建
export async function mediaAdd(data) {
	return request({ url: '/qunion/media/add', method: 'post', data });
}

// 媒体编辑
export async function mediaEdit(data) {
	return request({ url: '/qunion/media/edit', method: 'post', data });
}

// 检测媒体包名
export async function mediaCheckPackage(data) {
	return request({ url: '/media/check-pkg', method: 'post', data });
}

// 获取代码位列表
export async function getCodeList(params) {
  // return request({ url: 'adslot/admin/list', method: 'get', params });
  return request({ url: 'qunion/adslot/list-new', method: 'get', params });
}

// 获取代码位类型
export async function getCodeTypeList() {
  return request({
    url: 'common/dict',
    method: 'get',
    params: {
      type: 'adslot_ad_type_attribute'
    }
  });
}
// 获取全量应用列表
export async function getAllAppList() {
  return request({ url: 'media/all-list-qtt-union', method: 'get' });
}
// 获取样式号
export async function getStyleList(params) {
  return request({
    url: '/qunion/adslot/style',
    method: 'get',
    params
  });
}
// 新增代码位
export async function doAddCode(data) {
  return request({ url: '/qunion/adslot/add', method: 'post', data });
}
// 编辑代码位
export async function doEditCode(data) {
  return request({ url: '/qunion/adslot/update', method: 'post', data });
}
// 获取代码位详情
export async function getCodeDetail(params) {
  return request({ url: '/qunion/adslot/info', method: 'get', params });
}
